module.exports = __webpack_public_path__ + "img/222.missing_hend_sanitizer.8d3fd825.svg";